import { render, staticRenderFns } from "./ClassifiedFilterBox.vue?vue&type=template&id=89f0e418&scoped=true&lang=pug"
import script from "./ClassifiedFilterBox.vue?vue&type=script&lang=js"
export * from "./ClassifiedFilterBox.vue?vue&type=script&lang=js"
import style0 from "./ClassifiedFilterBox.vue?vue&type=style&index=0&id=89f0e418&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f0e418",
  null
  
)

export default component.exports